import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges, input } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

// LottieComponent is standalone — provideLottie({ player: playerFactory }) must
// be registered in app.config.ts for the player factory to be available.
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-animation',
  standalone: true,
  templateUrl: './animation.component.html',
  imports: [LottieComponent],
})
export class AnimationComponent implements OnInit, OnChanges, OnDestroy {
  readonly src = input('');
  readonly data = input<any>(null);
  readonly autoplay = input(false);
  readonly loop = input(false);
  readonly play = input(false);

  options: AnimationOptions = { path: '' };
  animationItem!: AnimationItem;
  destroyFn: (name: string) => void = () => {};
  name = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.autoplay()) {
      if (changes['play']?.currentValue && this.animationItem) {
        this.animationItem.play();
      } else if (this.animationItem) {
        this.animationItem.stop();
      }
    }
  }

  ngOnInit(): void {
    const data = this.data();
    if (data) {
      this.options = {
        ...this.options,
        autoplay: this.autoplay(),
        animationData: data,
        loop: this.loop(),
      };
    } else {
      this.options = {
        ...this.options,
        path: '/assets/animations/' + this.src(),
        autoplay: this.autoplay(),
        animationData: '',
        loop: this.loop(),
      };
    }
  }

  animationCreated(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
    this.destroyFn = animationItem.destroy.bind(animationItem);
    const _this = this;
    // Redirect destroyFn to delay destroy until route animation completes.
    this.animationItem.destroy = function (name: string): void {
      _this.name = name;
    };
  }

  ngOnDestroy(): void {
    this.destroyFn(this.name);
  }
}
